// O UpdateWithConfirmButton não roda a validação do form: sem esta checagem o PATCH
// saía com fuels vazio ou com linha sem fuelId e voltava 400 do backend.
export const isDefaultPointsFuelsReady = (formData: any): boolean => {
  const fuels = formData?.fuels
  if (!Array.isArray(fuels) || fuels.length === 0) return false
  if (!fuels.every(fuel => fuel && typeof fuel.fuelId === 'string' && fuel.fuelId)) return false
  return Boolean(formData.selectsAllPlaces) || (Array.isArray(formData.placeIds) && formData.placeIds.length > 0)
}
